import React from "react";

export default function DimensionHoverPopover({
  hover,
  viewportWidthPx,
  viewportHeightPx,
  pxPerMm = 3,
}) {
  if (!hover?.candidate) return null;

  const boxW = 56 * pxPerMm;
  const boxH = 16 * pxPerMm;
  const margin = 3 * pxPerMm;
  const gap = 4 * pxPerMm;

  const fontSize = 3 * pxPerMm;
  const smallFont = 2.5 * pxPerMm;
  const radius = 2 * pxPerMm;
  const padY = 1.5 * pxPerMm;
  const padX = 2 * pxPerMm;

  const left = Math.max(
    margin,
    Math.min(hover.xPx + gap, viewportWidthPx - boxW - margin)
  );

  const top = Math.max(
    margin,
    Math.min(hover.yPx + gap, viewportHeightPx - boxH - margin)
  );

  const candidate = hover.candidate;
  const title =
    candidate.kind === "point"
      ? "Point"
      : candidate.kind === "edge"
        ? "Edge"
        : "Face";

  const label =
    candidate.label ||
    candidate.name ||
    candidate.faceName ||
    candidate.axis ||
    "Reference";

  return (
    <div
      style={{
        position: "absolute",
        left,
        top,
        width: boxW,
        minHeight: boxH,
        background: "rgba(255,255,255,0.96)",
        border: `${Math.max(1, 0.15 * pxPerMm)}px solid #cbd5e1`,
        borderRadius: radius,
        boxShadow: "0 8px 24px rgba(15,23,42,0.18)",
        padding: `${padY}px ${padX}px`,
        zIndex: 200,
        pointerEvents: "none",
        fontSize,
        lineHeight: 1.2,
        color: "#0f172a",
        overflow: "hidden",
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 0.8 * pxPerMm }}>
        {title}
      </div>

      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          color: "#334155",
        }}
      >
        {label}
      </div>

      <div
        style={{
          marginTop: 1.2 * pxPerMm,
          color: "#64748b",
          fontSize: smallFont,
        }}
      >
        Tab = next reference
      </div>
    </div>
  );
}